import React, { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import ListIcon from "@mui/icons-material/List";
import Tooltip from "@mui/material/Tooltip";
import { Filter } from "../GarfoVtrPage/Filter";
import AlertDialog from "../../components/common/AlertDialog";
import { deleteTrip } from "../../actions/newVtrTrip";
import TripSections from "../../components/TripSections/TripSections";
import { Sections } from "../../constants/TripStatus";

const HPDesktop = ({ ...props }) => {
  const [tripId, setTripId] = useState(null);
  const [vesselPermit, setVesselPermit] = useState("");
  const [sailDate, setSailDate] = useState(null);
  const [filterSailDate, setFilterSailDate] = useState(null);
  const [landDate, setLandDate] = useState(null);
  const [filterLandDate, setFilterLandDate] = useState(null);
  const [open, setOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertTitle, setAlertTitle] = useState("");
  const [currentTrip, setCurrentTrip] = useState(null);
  const messageList = [
    "Please confirm Delete Trip on this device.  This action can not be undone!",
    "Please confirm Hide Trip on this device.  This action can not be undone!",
  ];
  const navigate = useNavigate();

  const handleClick = (input, tripId) => (event) => {
    event.preventDefault();
    setCurrentTrip(tripId);
    if (input === "delete") {
      setAlertTitle("Delete");
      setAlertMessage(messageList[0]);
      setOpen(true);
    } else if (input === "hide") {
      setAlertTitle("Hide");
      setAlertMessage(messageList[1]);
      setOpen(true);
    } else if (input === "List") {
      navigate(`${process.env.PUBLIC_URL}/vtr`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/vtr-trip-review`, {
        state: {
          trip_id: tripId,
          client_id: props.clientId,
        },
      });
    }
  };

  const handleVesselChange = (event, reason) => {
    event.preventDefault();
    let permitNbr = null;
    if (reason) {
      permitNbr = reason.PNUM;
    }
    setVesselPermit(permitNbr);
  };

  const handleDeleteTrip = (event) => {
    props.deleteTrip(event);
  };

  const handleDateChange = (input, date) => {
    let newDateTime = null;
    let bDateTime = null;
    if (date !== null) {
      newDateTime = moment(date, "YYMMDD");
      bDateTime = moment(newDateTime).format("YYMMDD");
    }
    if (input === "landDate") {
      setLandDate(newDateTime);
      setFilterLandDate(bDateTime);
    } else {
      setSailDate(newDateTime);
      setFilterSailDate(bDateTime);
    }
  };

  const handleTripChange = (event) => {
    event.preventDefault();
    setTripId(event.target.value);
  };

  const clearFilters = () => {
    window.location.reload();
  };

  let trips = props.trips.slice();

  if (tripId) {
    trips = trips.filter((trip) => {
      return trip.submission_type.toUpperCase() === "PAPER"
        ? trip.lowest_serial_num === tripId
        : trip.trip_id === tripId;
    });
  }
  if (vesselPermit) {
    trips = trips.filter((trip) => trip.vessel_permit_num.includes(vesselPermit));
  }
  if (filterSailDate) {
    trips = trips.filter((trip) => trip.date_sail.includes(filterSailDate));
  }
  if (filterLandDate) {
    trips = trips.filter((trip) => trip.date_land.includes(filterLandDate));
  }
  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Filter
          tripId={tripId}
          vesselPermit={vesselPermit}
          sailDate={sailDate}
          landDate={landDate}
          handleTripChange={handleTripChange}
          handleDateChange={handleDateChange}
          handleVesselChange={handleVesselChange}
          handleFilterClear={clearFilters}
          preferences={props.validation.validations.permit}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <Tooltip title="VTR Trip List">
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClick("List")}
          >
            <ListIcon />
          </Button>
        </Tooltip>
      </div>
      <Paper sx={{ width: "100%" }}>
        {Sections.map((section, idx) => {
          return (
            <TripSections
              key={idx}
              type={section.id}
              trips={trips.filter((trip) =>
                section.filter.includes(
                  trip.hasOwnProperty("trip_status") ? trip.trip_status : ""
                )
              )}
              title={section.title}
              handleClick={handleClick}
            />
          );
        })}
        {open && (
          <AlertDialog
            isVisible={open}
            title={alertTitle}
            content={alertMessage}
            client_id={props.clientId}
            trip_id={currentTrip}
            setIsVisible={setOpen}
            handleTrip={handleDeleteTrip}
          />
        )}
      </Paper>
    </>
  );
};

function mapStateToProps(state) {
  return { ...state };
}

const mapDispatchToProps = {
  deleteTrip,
};

export default connect(mapStateToProps, mapDispatchToProps)(HPDesktop);
